module.exports = __webpack_public_path__ + "static/img/16.4abd8db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zongce/16.jpg
// module id = iLVr
// module chunks = 1